import { render, staticRenderFns } from "./SampleDownloadButton.vue?vue&type=template&id=0f06e643"
import script from "./SampleDownloadButton.vue?vue&type=script&lang=js"
export * from "./SampleDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports